import { useMutation, useQueryClient } from "react-query";

import QAService from "@services/questionAnswer-service";
import { questionAnswerQueryKeys } from "./queryKeys";

export const useDeleteQuestionAnswerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id }: { id: string }) => {
      return new Promise((resolve, reject) => {
        QAService.delete(id, (err, res) => {
          if (err || !res) {
            return reject(err);
          }
          resolve(res.data);
        });
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(questionAnswerQueryKeys.all);
      },
    }
  );
};
